(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[456],{

/***/ 70619:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/on-som/[...uri]",
      function () {
        return __webpack_require__(88352);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Location": function() { return /* binding */ Location; },
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43291);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23097);
/* harmony import */ var _templates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67792);
/* harmony import */ var _templates_flexible_content__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53835);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25538);





var __N_SSG = true;
var Location = function(param) {
    var flexibleContent = param.flexibleContent, gridLocation = param.gridLocation;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_templates__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, gridLocation)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_templates_flexible_content__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                flexibleContent: flexibleContent
            })
        ]
    });
};
Location.getLayout = _components_Layout__WEBPACK_IMPORTED_MODULE_4__/* .getLayout */ .G;
/* harmony default export */ __webpack_exports__["default"] = (Location);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7061,7007,5538,6924,9774,2888,179], function() { return __webpack_exec__(70619); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);